export const SITE = {
  name: "JSE Painting Services",
  shortName: "JSE",
  tagline: "Hand-crafted painting for Fort Worth homes & businesses.",
  phone: "817-405-8718",
  phoneHref: "tel:+18174058718",
  email: "Jseservice2020@gmail.com",
  emailHref: "mailto:Jseservice2020@gmail.com",
  location: "Fort Worth, Texas",
  yearsExperience: "5+",
  yelp: "https://m.yelp.com/biz/jse-painting-service-fort-worth",
  homeAdvisor: "https://www.homeadvisor.com/rated.JSEPaintingServicesLLC.105819197.html",
};

export const IMAGES = {
  hero: "/gallery/painter.jpg",
};

export const GALLERY = [
  { key: "crew", src: "/gallery/painter.jpg", label: "JSE crew · Full prep & spray setup", caption: "Suited up for a full interior repaint — Fort Worth" },
  { key: "shaker", src: "/gallery/shaker.jpg", label: "Shaker cabinets · Fresh build", caption: "White shaker cabinet finish — Fort Worth new build" },
  { key: "darkWood", src: "/gallery/dark-wood.jpg", label: "Walnut-stained cabinetry", caption: "Rich dark stain restoration on raised-panel cabinets" },
  { key: "modernKitchen", src: "/gallery/modern-kitchen.png", label: "Modern kitchen · Two-tone", caption: "Charcoal cabinets with bright island — modern remodel" },
  { key: "blackTheater", src: "/gallery/blackout.jpg", label: "Blackout media room", caption: "Full blackout media room — walls, ceiling & doors" },
];

export const SERVICES = [
  { key: "interior", title: "Interior Painting", blurb: "Walls, ceilings, trim, cabinets — crisp lines, premium finishes, zero dust where it doesn't belong.", num: "01" },
  { key: "exterior", title: "Exterior Painting", blurb: "Stucco, siding, brick & wood. Weather-ready coatings built to handle Texas heat and storms.", num: "02" },
  { key: "commercial", title: "Commercial Work", blurb: "Storefronts, offices and multi-unit properties. Scheduled around your business hours.", num: "03" },
  { key: "residential", title: "Residential Homes", blurb: "From a single accent wall to a whole-home refresh — treated with the same care as our own.", num: "04" },
  { key: "detail", title: "Detail & Touch-Ups", blurb: "Cabinet refinishing, doors, trim, color matching and the small details that change a room.", num: "05" },
];

export const REASONS = [
  { title: "Locally owned in Fort Worth", body: "Born and raised here. Every job is in our backyard — and on our reputation." },
  { title: "5+ years of hands-on work", body: "Hundreds of homes and businesses, one trim line at a time." },
  { title: "24-hour service availability", body: "Emergency repaints, fresh listings, move-outs — we work when you need us." },
  { title: "Free, no-pressure estimates", body: "Walk-through, scope, honest pricing. No upsells. Decide on your time." },
];

export const TESTIMONIALS = [
  { name: "Marcus T.", source: "Yelp", body: "Best paint job we've had in 15 years of homeownership. JSE was on time, clean, and the trim lines are perfect." },
  { name: "Diana R.", source: "HomeAdvisor", body: "They painted our entire exterior over a weekend. Quote was honest, work was incredible, neighbors keep asking who did it." },
  { name: "Anthony L.", source: "Yelp", body: "We use JSE for all our rental turnovers. Reliable, fast, and the cabinets they refinished look brand new." },
  { name: "Priya S.", source: "HomeAdvisor", body: "Detail oriented is an understatement. They masked every outlet, moved furniture, and left the house cleaner than they found it." },
  { name: "Carlos M.", source: "Yelp", body: "Got three quotes in Fort Worth. JSE wasn't the cheapest but absolutely the most thorough. Worth every cent." },
];
